import { action, props } from 'ts-action';
import { QrsOnset } from '../../ecg/types/qrs-onset.type';
import { SkipHistory } from '../../undo/actions/undo.actions';

export const load = action(
  '[Scatter] load',
  props<{ onsets: QrsOnset[] } & SkipHistory>(),
);

export const loadFailed = action('[Scatter] loadFailed', props<SkipHistory>());
